import { Fancybox } from "@fancyapps/ui";
if (process.client) {
  window.fancybox = Fancybox
}